/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseAccordionPanelFragment} from '@amblique/contentful/app/contentful/fragments/accordion-panel/base-accordion-panel.fragment';
import {BaseAccordionFragment} from '@amblique/contentful/app/contentful/fragments/accordion/base-accordion.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const AccordionPanelFragment = gql`
  ${BaseAccordionFragment}
  ${BaseAccordionPanelFragment}
  ${BaseImageFragment}
  ${BaseVideoFragment}

  fragment AccordionPanelFragment on AccordionPanel {
    ...BaseAccordionPanelFragment

    accordionsCollection {
      items {
        __typename
        ... on Accordion {
          ...BaseAccordionFragment
        }
      }
    }
    accordionsCursorCollection {
      items {
        __typename
        ... on Accordion {
          ...BaseAccordionFragment
        }
      }
    }
    media {
      ... on Image {
        ...BaseImageFragment
      }
      ... on Video {
        ...BaseVideoFragment
      }
    }
  }
`;
